import bus from '@utils/bus';

class Store {
     remote = {
        isGetAllChannel: false,
        allChannel: [],
        firstChannel: [],
        secondChannel: [],
        thirdChannel: []
    }

    sync(data) {
        this.remote = {
            ...this.remote,
            ...data
        }
        console.warn(this.remote);
    }

    hasAllChannel() {
        return new Promise(async resolve => {
            if (!window.$cache) {
                return resolve()
            }
            bus.dispatch("loadingChange", true);
            while (true) {
                const channel = await window.$cache.get('channel')
                if (window.$cache && channel) {
                    bus.dispatch("loadingChange", false);
                    this.remote.channel = channel
                    resolve(true)
                    break
                }
                await Store.sleep(3)
            }
        })
    }

    /**
     * 
     * @param {number} s 睡眠秒数
     */
    static sleep(s) {
        return new Promise(resolve => {
            const timer = setTimeout(() => {
                resolve()
                clearTimeout(timer)
            }, s * 1000);
        })
    }
}


export const store = new Store()
window['store'] = store